import React from 'react';
import { motion } from 'framer-motion';
export function Comparison() {
  const rows = [{
    a: 'Rutinas que no encajan',
    b: 'Tiempo perdido + abandono'
  }, {
    a: 'Membresía de gimnasio',
    b: '$15.000/mes que no usás'
  }, {
    a: 'Planes sin mantenimiento',
    b: 'Rebote garantizado'
  }, {
    a: 'El mismo ciclo de siempre',
    b: 'El mismo lunes, el año que viene'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-50">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-51">
        ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
      </motion.h2>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-brand-card border border-brand-green/20 rounded-2xl overflow-hidden mb-12" data-id="element-52">
        <div className="grid grid-cols-2 bg-brand-darker border-b border-brand-green/20" data-id="element-53">
          <div className="p-4 md:p-6 font-bold text-gray-400 text-center md:text-left" data-id="element-54">
            Sin SuperPack
          </div>
          <div className="p-4 md:p-6 font-bold text-brand-green text-center md:text-left border-l border-brand-green/20" data-id="element-55">
            Costo Real
          </div>
        </div>

        <div className="divide-y divide-brand-green/10" data-id="element-56">
          {rows.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-brand-green/5 transition-colors" data-id="element-57">
              <div className="p-4 md:p-6 text-gray-300 text-sm md:text-base" data-id="element-58">
                {row.a}
              </div>
              <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base border-l border-brand-green/10" data-id="element-59">
                {row.b}
              </div>
            </div>)}
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="text-center" data-id="element-60">
        <h3 className="text-3xl md:text-5xl font-black" data-id="element-61">
          El próximo lunes{' '}
          <span className="text-brand-green" data-id="element-62">puede ser diferente.</span>
        </h3>
      </motion.div>
    </section>;
}